// DICOM / document counts and tags from the VE referrals payload
// (no_of_DICOM, no_of_documents, tag_names). Missing fields treat as 0 / [].

const f = (r, k) => (r?.data || r?.Data || {})[k];

function toCount(v) {
  if (v === null || v === undefined || v === '') return 0;
  const n = Number(v);
  return Number.isFinite(n) && n > 0 ? Math.floor(n) : 0;
}

export function getDicomCount(recordOrData) {
  const inner = recordOrData?.data || recordOrData?.Data || recordOrData || {};
  return toCount(inner.no_of_DICOM ?? inner.no_of_dicom);
}

export function getDocumentCount(recordOrData) {
  const inner = recordOrData?.data || recordOrData?.Data || recordOrData || {};
  return toCount(inner.no_of_documents);
}

/** Normalize tag_names (array, JSON string, or comma-separated) to string[]. */
export function getTagNames(recordOrData) {
  const inner = recordOrData?.data || recordOrData?.Data || recordOrData || {};
  const raw = inner.tag_names ?? inner.tags;
  if (raw == null || raw === '') return [];
  if (Array.isArray(raw)) {
    return raw.map((t) => String(t).trim()).filter(Boolean);
  }
  if (typeof raw === 'string') {
    const s = raw.trim();
    if (!s) return [];
    if (s.startsWith('[')) {
      try {
        const parsed = JSON.parse(s);
        if (Array.isArray(parsed)) {
          return parsed.map((t) => String(t).trim()).filter(Boolean);
        }
      } catch { /* fall through */ }
    }
    return s.split(/[,;|]/).map((t) => t.trim()).filter(Boolean);
  }
  return [];
}

export function hasDicom(recordOrData) {
  return getDicomCount(recordOrData) > 0;
}

/** Compact Images cell: "2 DICOM" / "—" with optional docs line handled by caller. */
export function formatDicomLabel(recordOrData) {
  const n = getDicomCount(recordOrData);
  return n > 0 ? `${n} DICOM` : '—';
}

export function formatDocumentsLabel(recordOrData) {
  const n = getDocumentCount(recordOrData);
  return n > 0 ? `${n} doc${n === 1 ? '' : 's'}` : '';
}

export function formatTagsLabel(recordOrData) {
  const tags = getTagNames(recordOrData);
  return tags.length > 0 ? tags.join(', ') : '—';
}

/** Export cell values (always numeric / joined tags, empty when absent). */
export function exportDicomCount(recordOrData) {
  const n = getDicomCount(recordOrData);
  return n > 0 ? String(n) : '0';
}

export function exportDocumentCount(recordOrData) {
  const n = getDocumentCount(recordOrData);
  return n > 0 ? String(n) : '0';
}

export function exportTags(recordOrData) {
  const tags = getTagNames(recordOrData);
  return tags.join(', ');
}

/** Include attachment fields in free-text search blobs. */
export function attachmentSearchText(recordOrData) {
  const parts = [
    formatDicomLabel(recordOrData),
    formatDocumentsLabel(recordOrData),
    ...getTagNames(recordOrData),
    f(recordOrData, 'no_of_DICOM'),
    f(recordOrData, 'no_of_documents'),
  ];
  return parts.filter(Boolean).join(' ').toLowerCase();
}
